@switch (variant()) {
  @case ('circularRegular') {
    <ng-container *ngTemplateOutlet="circularRingTpl" />
  }
  @case ('circularLarge') {
    <ng-container *ngTemplateOutlet="circularRingTpl" />
  }
  @case ('default') {
    <div
      class="cads-progress-bar cads-progress-bar--default"
      role="progressbar"
      [attr.aria-valuenow]="_ariaValueNow()"
      [attr.aria-valuemin]="_ariaValueMin()"
      [attr.aria-valuemax]="_ariaValueMax()"
      [attr.aria-labelledby]="_linearAriaLabelledBy()"
      [attr.aria-label]="_linearAriaLabel()"
    >
      @if (_showLinearHeader()) {
        <div class="cads-progress-bar__header">
          @if (config().title) {
            <span [id]="_ariaTitleDomId" class="cads-progress-bar__title">{{ config().title }}</span>
          }
          @if (config().headerValue) {
            <span class="cads-progress-bar__header-value">{{ config().headerValue }}</span>
          }
        </div>
      }
      <div class="cads-progress-bar__track cads-progress-bar__track--default" [style.background]="config().trackColor">
        <div
          class="cads-progress-bar__fill"
          [style.width.%]="_fillWidthPercent()"
          [style.background]="config().color"
        ></div>
      </div>
    </div>
  }
  @case ('segmented') {
    <div
      class="cads-progress-bar cads-progress-bar--segmented"
      role="progressbar"
      [attr.aria-valuenow]="_ariaValueNow()"
      [attr.aria-valuemin]="_ariaValueMin()"
      [attr.aria-valuemax]="_ariaValueMax()"
      [attr.aria-labelledby]="_linearAriaLabelledBy()"
      [attr.aria-label]="_linearAriaLabel()"
    >
      @if (_showLinearHeader()) {
        <div class="cads-progress-bar__header">
          @if (config().title) {
            <span [id]="_ariaTitleDomId" class="cads-progress-bar__title">{{ config().title }}</span>
          }
          @if (config().headerValue) {
            <span class="cads-progress-bar__header-value">{{ config().headerValue }}</span>
          }
        </div>
      }
      <div class="cads-progress-bar__segments">
        @for (seg of _segmentItems(); track $index) {
          <div class="cads-progress-bar__segment">
            <div
              class="cads-progress-bar__segment-track"
              [style.background]="config().trackColor"
            >
              <div
                class="cads-progress-bar__segment-fill"
                [style.width.%]="seg.fillPct"
                [style.background]="config().color"
              ></div>
            </div>
            @if (seg.label) {
              <span class="cads-progress-bar__segment-label">{{ seg.label }}</span>
            }
          </div>
        }
      </div>
    </div>
  }
  @case ('utilization') {
    <div
      class="cads-progress-bar cads-progress-bar--utilization"
      role="progressbar"
      [attr.aria-valuenow]="_ariaValueNow()"
      [attr.aria-valuemin]="_ariaValueMin()"
      [attr.aria-valuemax]="_ariaValueMax()"
      [attr.aria-labelledby]="_linearAriaLabelledBy()"
      [attr.aria-label]="_linearAriaLabel()"
    >
      @if (config().title) {
        <span [id]="_ariaTitleDomId" class="cads-progress-bar__title cads-progress-bar__title--block">{{ config().title }}</span>
      }
      <div
        class="cads-progress-bar__track cads-progress-bar__track--utilization"
        [style.background]="config().trackColor"
      >
        <div
          class="cads-progress-bar__fill"
          [style.width.%]="_fillWidthPercent()"
          [style.background]="config().color"
        ></div>
      </div>
      <div class="cads-progress-bar__footer">
        <span class="cads-progress-bar__footer-item">{{ _fromLabel() }}</span>
        <span class="cads-progress-bar__footer-item cads-progress-bar__footer-item--center">{{
          _currentLabel()
        }}</span>
        <span class="cads-progress-bar__footer-item cads-progress-bar__footer-item--end">{{ _totalLabel() }}</span>
      </div>
    </div>
  }
  @case ('mini') {
    <div
      class="cads-progress-bar cads-progress-bar--mini"
      role="progressbar"
      [attr.aria-valuenow]="_ariaValueNow()"
      [attr.aria-valuemin]="_ariaValueMin()"
      [attr.aria-valuemax]="_ariaValueMax()"
      [attr.aria-labelledby]="_linearAriaLabelledBy()"
      [attr.aria-label]="_linearAriaLabel()"
    >
      @if (config().title) {
        <span [id]="_ariaTitleDomId" class="cads-progress-bar__mini-title">{{ config().title }}</span>
      }
      <div class="cads-progress-bar__track cads-progress-bar__track--mini" [style.background]="config().trackColor">
        <div
          class="cads-progress-bar__fill"
          [style.width.%]="_fillWidthPercent()"
          [style.background]="config().color"
        ></div>
      </div>
      @if (config().valueLabel) {
        <span class="cads-progress-bar__mini-value" [style.color]="_miniValueColor()">{{ config().valueLabel }}</span>
      }
    </div>
  }
}

<ng-template #circularRingTpl>
  <div
    class="cads-progress-bar cads-progress-bar--circular"
    [class.cads-progress-bar--circular-large]="variant() === 'circularLarge'"
    role="progressbar"
    [attr.aria-valuenow]="_ariaValueNow()"
    [attr.aria-valuemin]="_ariaValueMin()"
    [attr.aria-valuemax]="_ariaValueMax()"
    [attr.aria-labelledby]="_linearAriaLabelledBy()"
    [attr.aria-label]="_linearAriaLabel()"
  >
    <svg
      class="cads-progress-bar__ring-svg"
      [attr.width]="_ringSize()"
      [attr.height]="_ringSize()"
      aria-hidden="true"
    >
      <circle
        [attr.cx]="_ringCenter()"
        [attr.cy]="_ringCenter()"
        [attr.r]="_ringRadius()"
        fill="none"
        [attr.stroke]="config().trackColor"
        [attr.stroke-width]="_strokeWidth()"
        stroke-linecap="round"
      />
      <circle
        class="cads-progress-bar__ring-progress"
        [attr.cx]="_ringCenter()"
        [attr.cy]="_ringCenter()"
        [attr.r]="_ringRadius()"
        fill="none"
        [attr.stroke]="config().color"
        [attr.stroke-width]="_strokeWidth()"
        stroke-linecap="round"
        [attr.stroke-dasharray]="_ringCircumference()"
        [attr.stroke-dashoffset]="_ringDashOffset()"
        [attr.transform]="_ringTransform()"
      />
    </svg>
    <div class="cads-progress-bar__circular-label">
      @if (config().title) {
        <span [id]="_ariaTitleDomId" class="cads-progress-bar__circular-value">{{ config().title }}</span>
      }
      @if (_showCircularSubtitle() && config().subtitle) {
        <span class="cads-progress-bar__circular-subtitle">{{ config().subtitle }}</span>
      }
    </div>
  </div>
</ng-template>
